import {
	Box, Button,
	Card, CardActions,
	CardContent,
} from "@mui/material"
import { formatDateWithYear } from "../../../utils/dates"
import NotificationSidebarButtons from "./NotificationSidebarButtons"
//import DiscreteOpenButton from "../../../utils/DiscreteOpenButton"
import {useState} from "react"
import "../../../styles/NotificationsAnimations.css"
import {useDispatch, useSelector} from "react-redux"
import {
	getRawNotification,
	markNotificationsAsRead,
	sendWorkspaceAccessRequest,
	NotificationType, selectCurrentPanelView, acceptWorkspaceInvite
} from "../../../reducers/notificationsSlice"
import {useSnackbar} from "notistack"
import {
	MANAGE_WORKSPACE_VIEW,
	setIsAddingNewMember,
	setManageWorkspaceView,
	setTargetUser
} from "../../../reducers/manageWorkspaceSlice"
import {openWorkspacePermissions} from "../../../reducers/dashboardModalControlSlice"
import NotificationStatusBadge from "./NotificationStatusBadge"
import {getLastClickedNotificationId} from "../../../reducers/NotificationScrollControlSlice"
import {NotificationItemBody} from "./NotificationItemBody"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export default function NotificationListItem({sharedCitationObject, clickHandler}) {
	const { workspaceId } = useWorkspaceContext()
	const sentByUser = sharedCitationObject.isSent
	const isSentView = useSelector((state) => selectCurrentPanelView(state, workspaceId)) === 2
	const showNotificationMessage = [NotificationType.ARTICLE_SHARE].includes(sharedCitationObject.type) && sharedCitationObject.message
	const [isFadingOut, setIsFadingOut] = useState(false)
	const dispatch = useDispatch()
	const {enqueueSnackbar} = useSnackbar()
	const notificationIdOfLastInteraction = useSelector((state) => getLastClickedNotificationId(state, workspaceId))

	const handleRequestAccess = (sharedCitationObject) => {
		dispatch(sendWorkspaceAccessRequest(sharedCitationObject.notificationId))
		dispatch(markNotificationsAsRead(sharedCitationObject.notificationId))
		enqueueSnackbar("A request has been sent to the workspace owner.", {variant: "success", autoHideDuration: 5000, })
	}

	const handleAcceptInvite = (sharedCitationObject) => {
		dispatch(acceptWorkspaceInvite(sharedCitationObject.notificationId))
		dispatch(markNotificationsAsRead(sharedCitationObject.notificationId))
	}

	const grantRequestAccess = async (sharedCitationObject) => {
		if(sharedCitationObject.sharedWorkspaceId !== workspaceId){
			enqueueSnackbar("You must switch to the workspace first", {variant: "error", autoHideDuration: 5000})
		} else {
			const { payload: rawNotification} = await dispatch(getRawNotification(sharedCitationObject))
			const user = rawNotification.sendingUser
			const newWorkspaceMemberDTO = { // add member DTO
				user: {...user},
				workspacePermissions: {
					read: true,
					write: false,
					admin: false,
				},
				selectedNoteIds: {}
			}
			dispatch(markNotificationsAsRead(sharedCitationObject.notificationId))
			dispatch(setIsAddingNewMember(true)) // set state flag that modal is adding new member
			dispatch(setTargetUser(newWorkspaceMemberDTO)) // set the newly created add member DTO
			dispatch(openWorkspacePermissions()) // open modal
			dispatch(setManageWorkspaceView(MANAGE_WORKSPACE_VIEW.MANAGE_MEMBER)) // open the panels where user permissions / notes can be set
		}
	}

	return (
		<Card
			elevation={0}
			variant={"note"}
			className={isFadingOut ? "notif-fadeout" : ""}
			sx={{
				display: "flex",
				alignItems: "center",
				padding: "0",
				borderRadius: "0px",
				marginBottom: "2px",
				boxSizing: "border-box",
				position: "relative",
				backgroundColor: "white",
				boxShadow: "none",
				"&:hover": {
					boxShadow: "0 0px 8px rgba(0, 0, 0, 0.7)",
					backgroundColor: "notes.crumbsBackground",
				},
				transition: "all ease-in-out 240ms",
				...(notificationIdOfLastInteraction === sharedCitationObject.notificationId && {
					borderTop: "3px solid",
					borderBottom: "3px solid",
					borderRight: "3px solid",
					borderColor: "primary.main",
				})
			}}
		>
			<NotificationSidebarButtons
				sharedCitationObject={sharedCitationObject}
				clickHandler={clickHandler}
				setIsFadingOut={setIsFadingOut}
			/>
			<CardContent sx={{
				display: "flex",
				justifyContent: "center",
				gap: "0.5rem",
				flexDirection: "column",
				width: "100%",
				minHeight: "6rem",
				//padding: "1rem",
				"&:last-child": { padding: "1rem" }, // this is the dumbest thing in MUI?
			}}>
				<Box
					sx={{
						flex: "1 0 100%",
						display: "flex",
						flexDirection: "row",
						alignItems: "start",
						flexWrap: "wrap",
					}}
				>
					<NotificationItemBody
						sharedCitationObject={sharedCitationObject}
						sentByUser={sentByUser}
					/>
					<span style={{color: "grey"}}>
						{formatDateWithYear(sharedCitationObject.date)}
					</span>
				</Box>
				<Box sx={{ margin: "0.5rem 0"}}>
					{ showNotificationMessage && (
						<>
							MESSAGE: <span style={{color: "grey"}}> {sharedCitationObject.message} </span>
						</>
					)}
				</Box>
				<CardActions sx={{padding: 0, justifyContent: "end"}}>
					{isSentView === false && !sharedCitationObject.isRead && (
						<>
							{sharedCitationObject.type === NotificationType.POST_REGISTER_INVITE && (
								<Button
									variant="contained"
									color="primary"
									size={"small"}
									onClick={() => handleRequestAccess(sharedCitationObject)}
								>
									Request Access
								</Button>
							)}
							{sharedCitationObject.type === NotificationType.WORKSPACE_INVITE && (
								<Button
									variant="contained"
									color="primary"
									size={"small"}
									onClick={() => handleAcceptInvite(sharedCitationObject)}
								>
									Accept Invite
								</Button>
							)}
							{sharedCitationObject.type === NotificationType.WORKSPACE_INVITE_RESPONSE && (
								<Button
									variant="contained"
									color="primary"
									size={"small"}
									onClick={() => grantRequestAccess(sharedCitationObject)}
								>
									Grant Access
								</Button>
							)}
						</>
					)}
					{ sharedCitationObject.isRead && <NotificationStatusBadge sharedCitationObject={sharedCitationObject} />}
				</CardActions>
			</CardContent>
		</Card>
	)
}